import messageListLayoutStore from '../messageListLayoutStore';
import getFallbackPreviewLinesToShow from '../../utils/getFallbackPreviewLinesToShow';
import resolveInlineToSCLZeroLine from '../../utils/resolveInlineToSCLZeroLine';

export default function getShowPreviewLinesInListView(): number {
    const messagePreviewStore = messageListLayoutStore();
    const previewLines =
        messagePreviewStore.showPreviewLinesInListView ?? getFallbackPreviewLinesToShow();

    return resolveInlineToSCLZeroLine(previewLines);
}
